import "./LetterPreview.scss";
import { useEffect, useState } from "react";
import { Alert, Loader, Text } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import PDFViewer from "@/components/PdfViewer/PDFViewer";
import { useEngagementLetterStore } from "@/utils/stores/engagementLetterStore";

interface LetterPreviewProps {
  content: { title: string; header: string; content: string };
}

const LetterPreview = ({ content: _content }: LetterPreviewProps) => {
  const { previewPdfUrl, isLoadingPreview, previewError, fetchPreviewPdf } =
    useEngagementLetterStore();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    // Fetch preview PDF when component mounts
    fetchPreviewPdf();
  }, [fetchPreviewPdf]);

  const handlePdfError = () => {
    setHasError(true);
    notifications.show({
      title: "Unable to load preview",
      message:
        "The PDF preview could not be loaded. Please try regenerating the preview.",
      color: "red",
    });
  };

  if (isLoadingPreview) {
    return (
      <div className="letter-preview-loading">
        <Loader size="lg" />
        <Text mt="md" fw={500}>
          Generating preview with attachments...
        </Text>
      </div>
    );
  }

  if (previewError) {
    return (
      <div className="letter-preview-error">
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Preview Error"
          color="red"
        >
          {previewError}
        </Alert>
      </div>
    );
  }

  if (!previewPdfUrl) {
    return (
      <div className="letter-preview-error">
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="No Preview Available"
          color="yellow"
        >
          Unable to generate preview. Please try again.
        </Alert>
      </div>
    );
  }

  if (hasError) {
    return (
      <div className="letter-preview-error">
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Preview Error"
          color="red"
        >
          Unable to load preview. Please try regenerating the preview.
        </Alert>
      </div>
    );
  }

  return (
    <div className="letter-preview">
      <PDFViewer
        url={previewPdfUrl}
        file={previewPdfUrl}
        onError={handlePdfError}
      />
    </div>
  );
};

export default LetterPreview;
